import API from "../../api";
import { queryClient } from "../../react-query"
import { toast } from "react-toastify";

import { useWhatsappOficial } from "../../../store/service-activation/useWhatsappOficial";

const BASE = 'whatsapp-oficial'

export class WhatsappOficialModel {
  actions = useWhatsappOficial.getState().actions

  async getStatus({ silent = false } = {}) {
    if (!silent) this.actions.setLoading(true)
    try {
      const result = await API.get(`${BASE}/status`)
      this.actions.setAccount(result.data?.account || { status: 'disconnected' })
      return result.data
    } catch (error) {
      console.error(error)
      if (!silent) toast.error('Não foi possível carregar o status do WhatsApp', { theme: 'colored' })
      return null
    } finally {
      if (!silent) this.actions.setLoading(false)
    }
  }

  /**
   * Envia ao backend o retorno do Embedded Signup.
   * O backend troca o `code` por business token, assina os webhooks e dispara
   * a sincronização de contatos e histórico (janela de 24h da Meta).
   */
  async onboard({ code, wabaId, phoneNumberId, coexistence }) {
    try {
      const result = await API.post(`${BASE}/onboard`, {
        code,
        wabaId,
        phoneNumberId,
        coexistence,
      })
      this.actions.setAccount(result.data?.account || { status: 'syncing' })
      queryClient.invalidateQueries({ queryKey: [BASE] })
      toast.success('WhatsApp conectado. Sincronizando seus dados...', { theme: 'colored' })
      return result.data
    } catch (error) {
      console.error(error)
      const message = error?.response?.data?.message || 'Não foi possível concluir a conexão'
      this.actions.setAccount({ status: 'error', error: message })
      toast.error(message, { theme: 'colored' })
      return null
    }
  }

  async getUsage() {
    try {
      const result = await API.get(`${BASE}/consumo`)
      this.actions.setUsage(result.data?.usage || {})
      return result.data
    } catch (error) {
      console.error(error)
      return null
    }
  }

  async retrySync() {
    try {
      const result = await API.post(`${BASE}/sincronizar`)
      this.actions.setAccount(result.data?.account || {})
      toast.success('Sincronização reiniciada', { theme: 'colored' })
      return result.data
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível reiniciar a sincronização', { theme: 'colored' })
      return null
    }
  }
}
